export { convertTrackingPayloadToGtmPayload } from './helpers';
export { TrackingEvents, TrackingEventsWithPayloads } from './event-definitions';

export const gtmTrackingEventName = 'gtmEvent';
